module.exports = __webpack_public_path__ + "img/gpjy.8fd48c2.png";